import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { setData } from 'src/storage/general.actions';
import { Router } from '@angular/router';

@Component({
  selector: 'app-validacion-error',
  templateUrl: './validacion-error.component.html',
  styleUrl: './validacion-error.component.scss'
})
export class ValidacionErrorComponent {
  private store = inject(Store);
  private router = inject(Router);

  /**
   * Limpia los datos del store
   */
  cleanStore(): void {
    this.store.dispatch(setData({
      key: 'Property',
      value: undefined,
      merge: false
    }));
    this.store.dispatch(setData({
      key: 'Tenant',
      value: undefined,
      merge: false
    }));
    this.store.dispatch(setData({
      key: 'PolicyHolder',
      value: undefined,
      merge: false
    }));
  }

  /**
   * Redirige al inicio del flujo
   */
  enviar(): void {
    this.cleanStore();
    this.router.navigate(['/seguros/hogar/arriendo/cotizador']).then(() => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    });
  }
}
